import {Injectable} from "@angular/core";
import {Router} from '@angular/router'
import {Subject} from "rxjs";
import {RealAuthenticationService} from "./real-authentication.service";

const MINUTES_UNITL_AUTO_LOGOUT = 15 // in mins
const CHECK_INTERVAL = 1500 // in ms
const STORE_KEY = 'lastAction';


@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {

  sessionExpired = new Subject<void>();

  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  constructor(private router: Router, private authService: RealAuthenticationService) {
    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(STORE_KEY, Date.now().toString());
  }

  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    //check if JWT token is expired
    const isTokenExpired: boolean = this.isTokenExpired(Number(this.authService.getLocalStorageExp()));
    if (isTokenExpired) {
      localStorage.clear();
      //TODO de fixat nu trebuie mereu sa faca erdirect
      // this.router.navigate(['/auth/login']);
    }

    if (isTimeout) {
      this.sessionExpired.next();
    }
  }

  isTokenExpired(expirationTime: number): boolean {
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > expirationTime;
  }
}
